import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function NouveautesPage() {
  const nouveautes = [
    {
      id: 1,
      badge: 'Nouveau',
      category: 'Livre',
      name: 'Aventure Spatiale Interactive',
      description: 'Un livre personnalisé avec réalité augmentée où votre enfant explore l\'univers',
      price: '39.90',
      image: 'https://public.readdy.ai/ai/img_res/506c572e86bbbe290d3e49d2b12b21a8.jpg',
      features: ['Réalité augmentée', 'Animations 3D', 'Son interactif', 'Application incluse'],
      isNew: true,
    },
    {
      id: 2,
      badge: 'Tendance',
      category: 'Film',
      name: 'Vidéo TikTok Personnalisée',
      description: 'Créez une vidéo virale avec votre enfant en personnage animé',
      price: '29.90',
      image: 'https://readdy.ai/api/search-image?query=A%20trendy%20TikTok%20style%20animated%20video%20featuring%20a%20child%20character%20dancing%20and%20having%20fun%2C%20modern%20social%20media%20aesthetic%2C%20vibrant%20colors%2C%20dynamic%20poses%2C%20Pixar%20Disney%20style%2C%20simple%20clean%20background%2C%20energetic%20atmosphere&width=500&height=600&seq=tiktokchar1&orientation=portrait',
      features: ['Format vertical', 'Musique tendance', '30 secondes', 'Prêt à partager'],
      isNew: true,
    },
    {
      id: 3,
      badge: 'Exclusif',
      category: 'Portrait',
      name: 'Portrait Famille Métavers',
      description: 'Votre famille transformée en avatars 3D pour le métavers',
      price: '59.90',
      image: 'https://readdy.ai/api/search-image?query=A%20futuristic%20metaverse%20style%20family%20portrait%20with%203D%20avatars%2C%20modern%20digital%20aesthetic%2C%20holographic%20elements%2C%20vibrant%20neon%20colors%2C%20Pixar%20Disney%20style%2C%20simple%20gradient%20background%2C%20innovative%20technology%20atmosphere&width=500&height=600&seq=metafam1&orientation=portrait',
      features: ['Avatars 3D', 'Compatible VR', 'NFT disponible', 'Haute résolution'],
      isNew: true,
    },
    {
      id: 4,
      badge: 'Nouveau',
      category: 'Événement',
      name: 'Invitation Holographique',
      description: 'Des invitations avec effet holographique pour un événement inoubliable',
      price: '34.90',
      image: 'https://readdy.ai/api/search-image?query=A%20holographic%20style%20event%20invitation%20with%20futuristic%20design%20elements%2C%20iridescent%20colors%2C%20sparkles%20and%20light%20effects%2C%20modern%20aesthetic%2C%20simple%20clean%20background%2C%20magical%20and%20innovative%20atmosphere&width=500&height=600&seq=holoinvite1&orientation=portrait',
      features: ['Effet holographique', 'Animation vidéo', 'QR code inclus', 'Format numérique'],
      isNew: true,
    },
    {
      id: 5,
      badge: 'Tendance',
      category: 'Livre',
      name: 'Livre Audio Personnalisé',
      description: 'Une histoire racontée avec la voix de votre choix et des effets sonores',
      price: '34.90',
      image: 'https://readdy.ai/api/search-image?query=An%20audiobook%20concept%20with%20a%20child%20character%20listening%20to%20magical%20stories%2C%20headphones%2C%20sound%20waves%2C%20musical%20notes%2C%20Pixar%20Disney%20style%2C%20warm%20colors%2C%20simple%20clean%20background%2C%20immersive%20atmosphere&width=500&height=600&seq=audiobook1&orientation=portrait',
      features: ['Narration personnalisée', 'Effets sonores', 'Musique originale', 'Téléchargement MP3'],
      isNew: false,
    },
    {
      id: 6,
      badge: 'Exclusif',
      category: 'Film',
      name: 'Série Animée Personnalisée',
      description: 'Une mini-série de 5 épisodes avec votre enfant comme héros',
      price: '149.90',
      image: 'https://readdy.ai/api/search-image?query=An%20animated%20series%20concept%20showing%20a%20child%20superhero%20character%20in%20different%20action%20scenes%2C%20episode%20thumbnails%2C%20vibrant%20colors%2C%20Pixar%20Disney%20style%2C%20simple%20clean%20background%2C%20exciting%20adventure%20atmosphere&width=500&height=600&seq=series1&orientation=portrait',
      features: ['5 épisodes', '3 min chacun', 'Histoire continue', 'Personnages récurrents'],
      isNew: true,
    },
    {
      id: 7,
      badge: 'Nouveau',
      category: 'Portrait',
      name: 'Portrait IA Artistique',
      description: 'Un portrait créé par intelligence artificielle dans le style de grands maîtres',
      price: '44.90',
      image: 'https://readdy.ai/api/search-image?query=An%20artistic%20AI%20generated%20portrait%20in%20the%20style%20of%20famous%20painters%2C%20person%20with%20artistic%20interpretation%2C%20impressionist%20colors%2C%20painterly%20texture%2C%20simple%20elegant%20background%2C%20sophisticated%20artistic%20atmosphere&width=500&height=600&seq=aiartport1&orientation=portrait',
      features: ['Style Van Gogh', 'Style Picasso', 'Style Monet', 'Qualité musée'],
      isNew: true,
    },
    {
      id: 8,
      badge: 'Tendance',
      category: 'Événement',
      name: 'Filtre Instagram Personnalisé',
      description: 'Créez votre propre filtre Instagram pour vos événements',
      price: '79.90',
      image: 'https://readdy.ai/api/search-image?query=An%20Instagram%20filter%20concept%20with%20augmented%20reality%20elements%2C%20face%20effects%2C%20sparkles%20and%20animations%2C%20modern%20social%20media%20aesthetic%2C%20vibrant%20colors%2C%20simple%20clean%20background%2C%20fun%20and%20trendy%20atmosphere&width=500&height=600&seq=instafilter1&orientation=portrait',
      features: ['Effet AR', 'Animations', 'Partage facile', 'Statistiques incluses'],
      isNew: false,
    },
    {
      id: 9,
      badge: 'Exclusif',
      category: 'Livre',
      name: 'Livre Écologique Personnalisé',
      description: 'Un livre imprimé sur papier recyclé avec encres végétales',
      price: '32.90',
      image: 'https://readdy.ai/api/search-image?query=An%20eco-friendly%20personalized%20storybook%20with%20nature%20theme%2C%20child%20character%20learning%20about%20environment%2C%20green%20colors%2C%20natural%20elements%2C%20Pixar%20Disney%20style%2C%20simple%20clean%20background%2C%20sustainable%20and%20educational%20atmosphere&width=500&height=600&seq=ecobook1&orientation=portrait',
      features: ['Papier recyclé', 'Encres végétales', 'Emballage biodégradable', 'Histoire écologique'],
      isNew: true,
    },
  ];

  const categories = [
    { id: 'tous', name: 'Toutes les nouveautés', icon: 'ri-star-line' },
    { id: 'livre', name: 'Livres', icon: 'ri-book-line' },
    { id: 'film', name: 'Films', icon: 'ri-film-line' },
    { id: 'portrait', name: 'Portraits', icon: 'ri-user-line' },
    { id: 'evenement', name: 'Événements', icon: 'ri-calendar-line' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-yellow-50 via-orange-50 to-pink-50"></div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-primary-yellow rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-primary-coral rounded-full blur-3xl"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full shadow-soft mb-6">
              <i className="ri-flashlight-line text-primary-yellow"></i>
              <span className="font-quicksand font-semibold text-gray-700">Dernières Innovations</span>
            </div>
            <h1 className="text-6xl font-fredoka font-bold text-gray-900 mb-6">
              Nos{' '}
              <span className="bg-gradient-to-r from-yellow-500 via-orange-500 to-pink-600 bg-clip-text text-transparent">
                Nouveautés
              </span>
            </h1>
            <p className="text-xl font-quicksand text-gray-600 max-w-3xl mx-auto mb-8">
              Découvrez nos dernières créations et innovations technologiques pour des souvenirs encore plus magiques et personnalisés
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  className="px-6 py-3 bg-white hover:bg-gray-50 text-gray-700 font-quicksand font-semibold rounded-full shadow-soft hover:shadow-soft-lg transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
                >
                  <i className={`${cat.icon} w-5 h-5 flex items-center justify-center`}></i>
                  <span>{cat.name}</span>
                </button>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Nouveautés Grid */}
      <section className="py-20 bg-neutral-lighter">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {nouveautes.map((item, index) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Link
                  to={`/produit/${item.id}`}
                  className="group block bg-white rounded-3xl overflow-hidden shadow-soft hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-2 cursor-pointer"
                >
                  {/* Image */}
                  <div className="relative w-full h-96 overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    {/* Badges */}
                    <div className="absolute top-4 left-4 flex flex-col gap-2">
                      <div className={`px-3 py-1 rounded-full backdrop-blur-sm font-quicksand font-bold text-sm ${
                        item.badge === 'Nouveau' 
                          ? 'bg-primary-yellow/90 text-gray-900'
                          : item.badge === 'Tendance'
                          ? 'bg-primary-coral/90 text-white'
                          : 'bg-primary-mint/90 text-gray-900'
                      }`}>
                        {item.badge}
                      </div>
                      <div className="px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full">
                        <span className="font-quicksand font-semibold text-sm text-gray-900">
                          {item.category}
                        </span>
                      </div>
                    </div>
                    {item.isNew && (
                      <div className="absolute top-4 right-4">
                        <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full shadow-soft animate-pulse">
                          <i className="ri-flashlight-fill text-white text-xl"></i>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-2">
                      {item.name}
                    </h3>
                    <p className="font-quicksand text-gray-600 text-sm mb-4">
                      {item.description}
                    </p>

                    {/* Features */}
                    <div className="space-y-2 mb-4">
                      {item.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center gap-2">
                          <i className="ri-star-fill text-primary-yellow text-sm"></i>
                          <span className="font-quicksand text-sm text-gray-600">{feature}</span>
                        </div>
                      ))}
                    </div>

                    <div className="flex items-center justify-between mb-4">
                      <div>
                        <div className="text-xs font-quicksand text-gray-500 mb-1">
                          À partir de
                        </div>
                        <div className="text-3xl font-fredoka font-bold text-gray-900">
                          {item.price}€
                        </div>
                      </div>
                    </div>

                    <button className="w-full px-6 py-3 bg-gradient-to-r from-yellow-500 to-orange-500 text-white font-quicksand font-semibold rounded-full group-hover:shadow-colored-blue transition-all duration-300 whitespace-nowrap flex items-center justify-center gap-2">
                      <i className="ri-shopping-cart-line"></i>
                      <span>Découvrir</span>
                    </button>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Innovation Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-5xl font-fredoka font-bold text-gray-900 mb-4">
              Pourquoi choisir nos nouveautés ?
            </h2>
            <p className="text-lg font-quicksand text-gray-600 max-w-2xl mx-auto">
              Des technologies innovantes pour des créations toujours plus magiques
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-lightbulb-flash-line',
                title: 'Innovation',
                description: 'Les dernières technologies pour des créations uniques',
                color: 'from-yellow-500 to-orange-500',
              },
              {
                icon: 'ri-vip-crown-line',
                title: 'Exclusivité',
                description: 'Des produits que vous ne trouverez nulle part ailleurs',
                color: 'from-purple-500 to-pink-500',
              },
              {
                icon: 'ri-rocket-line',
                title: 'Tendances',
                description: 'Toujours à la pointe des dernières tendances',
                color: 'from-blue-500 to-teal-500',
              },
              {
                icon: 'ri-heart-line',
                title: 'Qualité',
                description: 'Le même niveau de qualité que nos créations classiques',
                color: 'from-pink-500 to-red-500',
              },
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="text-center"
              >
                <div className={`w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-gradient-to-br ${item.color} rounded-2xl shadow-soft`}>
                  <i className={`${item.icon} text-4xl text-white`}></i>
                </div>
                <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                  {item.title}
                </h3>
                <p className="font-quicksand text-gray-600">
                  {item.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-24 bg-gradient-to-br from-yellow-500 via-orange-500 to-pink-600">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-white/20 backdrop-blur-sm rounded-2xl">
              <i className="ri-mail-line text-5xl text-white"></i>
            </div>
            <h2 className="text-5xl font-fredoka font-bold text-white mb-6">
              Restez informé de nos nouveautés
            </h2>
            <p className="text-xl font-quicksand text-white/90 mb-10">
              Inscrivez-vous à notre newsletter pour être le premier à découvrir nos nouvelles créations
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
              <input
                type="email"
                placeholder="Votre adresse email"
                className="flex-1 px-6 py-4 rounded-full font-quicksand text-gray-900 focus:outline-none focus:ring-4 focus:ring-white/30"
              />
              <button className="px-8 py-4 bg-white text-gray-900 font-quicksand font-bold rounded-full hover:shadow-soft-lg transition-all duration-300 whitespace-nowrap cursor-pointer">
                S'inscrire
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}